import SearchNormal from '@/app/_components/ui/icons/SearchNormal.svg';
import React, { useState } from 'react';
import { useRouter } from 'next/navigation';

export default function PriceListSearchForm({ slug }) {
  const router = useRouter();
  const [value, setValue] = useState('');
  const submitSearchForm = () => {
    router.push(`/page/${slug}?s=${value}`);
  };
  return (
    <div className="header-search-form flex-1 md:pr-4 relative">
      <form className="relative" onSubmit={submitSearchForm}>
        <input
          onChange={(e) => setValue(e.target.value)}
          type="text"
          className="form-control block w-full pr-10 py-3  text-gray-700  bg-clip-padding
                                       border-none placeholder:text-gray-400 placeholder:text-xs rounded-md bg-light-gray-100  m-0 focus:text-gray-700 focus:bg-white  focus:outline-none"
          placeholder="محصول مورد نظر خود را جستجو کنید "
          // value=""
          name="s"
          autoComplete="off"
        />
        <span className="absolute top-2.5 right-3">
          <SearchNormal />
        </span>
        <button
          type="submit"
          className=" leading-8 y-2 rounded-md hover:shadow-primary transition text-white text-sm  bg-color-primary mt-2 md:mt-0 md:absolute left-2 top-2 w-full md:w-[165px]"
        >
          جستجو
        </button>
      </form>
    </div>
  );
}
